import { useIntl } from "react-intl"
import { useEffect, useState } from "react"
import { Button } from "primereact/button"
import HistoricBudgetsView from "./HistoricBudgetsView"
import CRUBudgetView from "./CRUBudgetView"
import './Budget.scss'
import { BudgetDTO, defaultBudgetDTO } from "../../dto/budget/BudgetDTO"
import { EBudgetGridOptions, EBudgetGridOptionsValues } from "../../enums/EBudgetGridOptions"
import BudgetPreview from "./BudgetPreview"
import PrintBudgetModal from "./PrintBudgetModal"
import React from "react"
import PreinvoiceFromBudgetView from "./PreinvoiceFromBudgetView"
import { useSearchParams } from 'react-router';

export default function BudgetView() {

    const [searchParams] = useSearchParams();
    const intl = useIntl();
    const [tabIndex, setTabIndex] = useState<number>(2);
    const [selectedAction, setSelectedActionConst] = useState<number>(-1);
    const [selectedBudget, setSelectedBudget] = useState<BudgetDTO>(defaultBudgetDTO);
    const [openPrintBudgetModal, setOpenPrintBudgetModal] = useState<boolean>(false); 
    
    const showNewBudgetButton = (tabIndex == 2) && ((selectedAction != EBudgetGridOptionsValues[EBudgetGridOptions.CREATE] && selectedAction != EBudgetGridOptionsValues[EBudgetGridOptions.EDIT] && selectedAction != EBudgetGridOptionsValues[EBudgetGridOptions.DUPLICATE]));

    const showCRUBudget = ((selectedAction == EBudgetGridOptionsValues[EBudgetGridOptions.CREATE] || selectedAction == EBudgetGridOptionsValues[EBudgetGridOptions.EDIT] || selectedAction == EBudgetGridOptionsValues[EBudgetGridOptions.DUPLICATE]));

    const setSelectedAction = (action:number) => {
        setSelectedActionConst(action);
        if((action == EBudgetGridOptionsValues[EBudgetGridOptions.CREATE]) || (action == EBudgetGridOptionsValues[EBudgetGridOptions.EDIT]) || (action == EBudgetGridOptionsValues[EBudgetGridOptions.DUPLICATE])){
            setTabIndex(1);
            return;
        }
        setTabIndex(2);
    }
    
    const onCloseCRUBudgetView = () => {
        setSelectedBudget(defaultBudgetDTO);
        setSelectedAction(-1); // nada seleccionado
        setTabIndex(2);  
    }

    return (
        <div className="viewContainer nv-scope nv-page budget-view-container">
            {
            (selectedAction != EBudgetGridOptionsValues[EBudgetGridOptions.PREVIEW] &&
            selectedAction != EBudgetGridOptionsValues[EBudgetGridOptions.PREINVOICE])
            &&
            <React.Fragment>
                <div className="nv-head-row">
                    <h1 className="nv-h1">{!showCRUBudget ? intl.formatMessage({ id: 'Budgets' })
                        : selectedAction == EBudgetGridOptionsValues[EBudgetGridOptions.EDIT] ? 'Editar presupuesto'
                        : selectedAction == EBudgetGridOptionsValues[EBudgetGridOptions.DUPLICATE] ? 'Duplicar presupuesto'
                        : 'Nuevo presupuesto'}</h1>
                    {showNewBudgetButton && <Button className="buttonMain" icon="pi pi-plus-circle" label="Crear" onClick={()=>{
                        setSelectedBudget({...defaultBudgetDTO, professionalActivities: [], disposables: [], equipments: [], nutritionalSupportItems: [], medicines: [], extras: []}); //Los [] explicitos son para evitar que ante un nuevo creado, se mantengan los valores del anterior
                        setSelectedAction(EBudgetGridOptionsValues[EBudgetGridOptions.CREATE]);
                    }}/>}
                </div>
                {(tabIndex == 1) && <CRUBudgetView budget={selectedBudget} hideView={onCloseCRUBudgetView}></CRUBudgetView>}
                {(tabIndex == 2) && <HistoricBudgetsView selectedAction={selectedAction} setSelectedAction={setSelectedAction} setSelectedBudget={setSelectedBudget} setOpenPrintBudgetModal={setOpenPrintBudgetModal} filterHospitalization={false}></HistoricBudgetsView>}
                
            </React.Fragment>}
            {selectedAction == EBudgetGridOptionsValues[EBudgetGridOptions.PREVIEW] && <BudgetPreview setSelectedAction={setSelectedAction} selectedBudget={selectedBudget} setSelectedBudget={setSelectedBudget} setOpenPrintBudgetModal={setOpenPrintBudgetModal}></BudgetPreview>}
            {selectedAction == EBudgetGridOptionsValues[EBudgetGridOptions.PREINVOICE] && <PreinvoiceFromBudgetView budget={selectedBudget} hideView={onCloseCRUBudgetView} setSelectedAction={setSelectedAction} />}
            <PrintBudgetModal budget={selectedBudget.budget??0} openPrintBudgetModal={openPrintBudgetModal} setOpenPrintBudgetModal={setOpenPrintBudgetModal} ></PrintBudgetModal>
        </div>
    )
}
